import { FormattedMessage } from 'react-intl'

import { HeaderIconUnauthenticated } from 'components/Icons'
import { Card } from 'components/Layout'

import { IconContainer } from '../IconContainer'
import { Wrapper } from '../Wrapper'

export const Unauthorized = () => (
	<Wrapper>
		<Card>
			<IconContainer>
				<h1>
					<FormattedMessage id='flow.unauthorized.title' defaultMessage='Link is invalid' />
				</h1>
				<HeaderIconUnauthenticated />
				<p>
					<FormattedMessage
						id='flow.unauthorized.description'
						defaultMessage='Please use the link provided to you by your advisor. If the issue persists, please reach out to them.'
					/>
				</p>
			</IconContainer>
		</Card>
	</Wrapper>
)
